import React, {useState} from 'react'

import '../../../styles/barra-navegacion.css'
import MenuCompleto from './MenuCompleto'
import MenuResponsive from './MenuResponsive'

import { 
    Dropdown,
    Menu,
} from 'antd'

import { 
    CaretDownOutlined,
} from '@ant-design/icons'
import {Link} from 'gatsby'

const NavBar = ({english}) => {

    const [idioma, setIdioma] = useState(english ? 'English' : 'Español')

    const goHome = e => {
        window.location = english ? '/en' : '/'
    }

    const menu = (
        <Menu>
            <Menu.Item key="Español">
                <Link 
                    onClick={() => setIdioma('Español')} 
                    href="/"
                >Español</Link>
            </Menu.Item>
            <Menu.Item key="English">
                <Link
                    onClick={() => setIdioma('English')} 
                    href="/en"
                >English</Link>
            </Menu.Item>
        </Menu>
    );

    return (
        <div 
            className={`barra-navegacion`} 
            id="inicio"  
        >
            <MenuResponsive english={english} />
            <div className="imagen">
                <img style={{cursor: 'pointer'}} alt="" src="/images/cabo-marques.jpg" onClick={goHome}/>
            </div>
            <div className="idioma">
                <Dropdown 
                    overlay={menu} 
                    placement="bottomLeft"
                    overlayStyle={{maxWidth: 20}}
                >
                    <p>{idioma}   <CaretDownOutlined /></p>
                </Dropdown>
            </div>
            <MenuCompleto  english={english}/>
        </div>
    )
}

export default NavBar